import { ADMIN_PERMISSIONS, ADMIN_ROUTE_PERMISSIONS } from '../constants';

export const permissionLabels = {
  [ADMIN_PERMISSIONS.DASHBOARD_VIEW]: 'Dashboard',
  [ADMIN_PERMISSIONS.KYC_REVIEW]: 'Employer KYC',
  [ADMIN_PERMISSIONS.CONFIG_MANAGE]: 'Platform Configs and Tag Taxonomy',
  [ADMIN_PERMISSIONS.LOGS_VIEW]: 'Audit Logs',
  [ADMIN_PERMISSIONS.MONITORING_VIEW]: 'Operations Pages',
  [ADMIN_PERMISSIONS.ADMINS_MANAGE]: 'Admins & RBAC',
  [ADMIN_PERMISSIONS.QUESTION_BANKS_VIEW]: 'Question Banks',
  [ADMIN_PERMISSIONS.QUESTION_BANKS_MANAGE]: 'Question Bank Management',
  [ADMIN_PERMISSIONS.NOTIFICATIONS_VIEW]: 'Communications',
  [ADMIN_PERMISSIONS.NOTIFICATIONS_MANAGE]: 'Communications Management',
  [ADMIN_PERMISSIONS.BILLING_VIEW]: 'Billing',
  [ADMIN_PERMISSIONS.BILLING_MANAGE]: 'Billing Management',
  [ADMIN_PERMISSIONS.TICKETS_VIEW]: 'Support Tickets',
  [ADMIN_PERMISSIONS.TICKETS_MANAGE]: 'Support Ticket Management'
};

export const isSuperAdmin = (user) => user?.adminRole === 'super_admin';

export const hasPermission = (user, permission) => {
  if (!permission) return true;
  if (isSuperAdmin(user)) return true;
  return Array.isArray(user?.permissions) && (
    user.permissions.includes('*') || user.permissions.includes(permission)
  );
};

export const hasAnyPermission = (user, permissions = []) => permissions.some((permission) => hasPermission(user, permission));

export const getPermissionLabel = (permission) => permissionLabels[permission] || permission;

export const routePermissionMap = [
  { prefix: '/dashboard', permission: ADMIN_PERMISSIONS.DASHBOARD_VIEW },
  ...ADMIN_ROUTE_PERMISSIONS.map((route) => ({
    prefix: route.path,
    permission: route.permission
  }))
];

export const getRouteRequirement = (pathname = '') => (
  [...routePermissionMap]
    .sort((a, b) => b.prefix.length - a.prefix.length)
    .find((route) => pathname === route.prefix || pathname.startsWith(`${route.prefix}/`))
);

export const canAccessPath = (user, pathname = '') => {
  const requirement = getRouteRequirement(pathname);
  return requirement ? hasPermission(user, requirement.permission) : true;
};

export const getDefaultAllowedPath = (user) => {
  const route = routePermissionMap.find((item) => hasPermission(user, item.permission));
  return route?.prefix || '/dashboard';
};
